import { observable, action, flow, computed, runInAction } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import { openCardTextLess, oldOpenCardText } from 'utils/constants';
import Serv from './MemCardMsgServ';
import * as _ from 'lodash';

class MemCardMsgMod {
  // 报错信息
  @observable errorMessage = '';
  @observable examine = 0;
  @observable errorStatus = 0;
  @observable cardCode = '';
  // 证件正反面图片
  @observable imgList = [];
  @observable certificateTypeList = [];
  // 是否被邀请开卡
  @observable isInvite = '';

  // 开卡类型: '3' - 自主开卡，'4' - 会员自主升级，'5' - 会员新客注册
  @observable applyType = '3';

  // 客人的ID，传给后台,新客注册时候用到(其他场景无此字段)
  @observable agentId = '';

  // 开卡的手机号
  @observable phone = '';

  // 实体卡号、实体卡密码
  @observable physicalCardNum = '';

  @observable physicalCardPwd = '';

  // 商户名称、经营地址、详细地址
  @observable businessName = '';

  @observable businessAddress = null;

  @observable detailAddress = '';

  // 民族列表、银行总行列表
  @observable nationList = [];

  @observable headBankList = [];

  // 初始化健康顾问编号、编辑的健康顾问编号、健康顾问姓名、销售顾问编号、销售顾问姓名、本人真实姓名。（健康顾问姓名为null代表未查是否有此人，为''时代表查无此人，为其它时，代表其名字， saleName同理）。
  @observable initHealthy = '';

  @observable healthy = '';

  @observable healthyName = null;

  @observable sale = '';

  // 乘星吻月 安置网
  @observable areaResettle = Stores.AppMod.isWY ? '' : 'leftCardCode'; // ABC区 A区-leftCardCode B区-rightCardCode C区-centerCardCode

  @observable areaResettleDetail = {}; // 乘星吻月安置网情况

  @observable saleName = null;

  @observable realName = '';

  // 证件类型，证件号，生日，性别，由于picker的value 要数组，为方便，凡是select的value，都用数组存储值，取第一项就好了
  @observable certType = 1;

  // 所在区域
  @observable belongArea = 1;

  @observable certNum = '';

  @observable birth = '';

  @observable gender = '';

  // 文化程度，职业，民族
  @observable level = '';

  @observable job = '';

  @observable nation = '';

  // 银行地址选择、总行、支行id、支行名、卡号
  @observable bankAddress = null;

  @observable headBankId = '';

  @observable branchBankId = '';

  @observable branchBankName = '';

  @observable bankNum = '';

  // 是否同意协议
  @observable isAgree = false;

  @observable healthyStatus = '';

  @observable saleStatus = '';

  // 根据销售顾问是否显示所在区域
  @observable isShowArea = false;

  @observable belongSystem = '';

  // 入口名称，仅用于生命周期埋点
  @observable inletTitle = '';

  // 是否修改过销售顾问，乘星吻月体系修改销售顾问下单时要增加销售顾问限制3跳线的校验,只要销售顾问input框聚焦过就算修改，重新中ABC区需要将该标志位置回false
  @observable isSaleChange = false;

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 初始化表单信息
   */
  @action
  initData() {
    const cardFillMsg = Util.getLocalCache(Config.localStorageKeys.member_cardFillMsg) || {};
    if (!cardFillMsg.phone || cardFillMsg.phone != this.phone) return;
    const {
      businessName,
      businessAddress,
      detailAddress,
      // password,
      sale,
      realName,
      certType,
      certNum,
      birth,
      gender,
      level,
      job,
      nation,
      bankNum,
      bankAddress,
      headBankId,
      branchBankId,
      branchBankName
    } = cardFillMsg;
    this.changeState({
      businessName,
      businessAddress,
      detailAddress,
      sale,
      realName,
      certType,
      certNum,
      birth,
      gender,
      level,
      job,
      nation,
      bankAddress,
      headBankId,
      branchBankId,
      branchBankName,
      bankNum
    });
    if (sale) {
      this.getMemberName('saleName', sale);
    }
  }

  /**
   * 清除全部数据
   */
  @action
  clear() {
    this.agentId = '';
    this.physicalCardNum = '';
    this.physicalCardPwd = '';
    this.businessName = '';
    this.businessAddress = null;
    this.detailAddress = '';
    // this.password = '';
    // this.passwordAgain = '';
    this.nationList = [];
    this.headBankList = [];
    this.initHealthy = '';
    this.healthy = '';
    this.healthyName = null;
    this.sale = '';
    this.saleName = null;
    this.realName = '';
    this.certType = 1;
    this.certNum = '';
    this.birth = '';
    this.gender = '';
    this.level = '';
    this.job = '';
    this.nation = '';
    this.bankAddress = null;
    this.headBankId = '';
    this.branchBankId = '';
    this.branchBankName = '';
    this.bankNum = '';
    this.isAgree = false;
    this.belongArea = 1;
    this.isSaleChange = false;
    this.areaResettle = Stores.AppMod.isWY ? '' : 'leftCardCode';
    this.areaResettleDetail = {};
  }

  @action
  resetData() {
    // this.agentId = '';
    this.physicalCardNum = '';
    this.physicalCardPwd = '';
    this.businessName = '';
    this.businessAddress = null;
    this.detailAddress = '';
    this.nationList = [];
    this.headBankList = [];
    // this.initHealthy = '';
    // this.healthy = '';
    // this.healthyName = null;
    // this.sale = '';
    // this.saleName = null;
    this.realName = '';
    this.certType = 1;
    this.certNum = '';
    this.birth = '';
    this.gender = '';
    this.level = '';
    this.job = '';
    this.nation = '';
    this.bankAddress = null;
    this.headBankId = '';
    this.branchBankId = '';
    this.branchBankName = '';
    this.bankNum = '';
    // this.isAgree = false;
    this.belongArea = 1;
  }

  // 判断当前区域代码是否为新加坡的区域代码 '65'
  @computed get isSingapore() {
    return Stores.AppMod.areaCode === '65';
  }

  /**
   * 获取民族列表
   */
  getNationList = flow(function* (memberNum) {
    try {
      const { data } = yield Serv.getNationList({ cardCode: memberNum });
      this.cardCode = memberNum;
      if (Array.isArray(data)) {
        this.nationList = data.map((_val) => ({
          label: _val.name,
          value: _val.id
        }));
      }
    } catch (error) {}
  });

  /**
   * 民族校验
   */
  nationValidate = flow(function* () {
    try {
      const { resultCode } = yield Serv.nationValidate({
        healthConsultantNum: this.healthy,
        nation: this.nation
      });
      return resultCode;
    } catch (error) {}
  });

  /**
   * 获取银行总行列表
   */
  getHeadBankList = flow(function* () {
    try {
      const { data } = yield Serv.getHeadBankList();
      if (Array.isArray(data)) {
        this.headBankList = data.map((_val) => ({
          label: _val.name,
          value: `${_val.id}`,
          name: _val.name
        }));
      }
    } catch (error) {}
  });

  /**
   * 获取用户姓名
   * @param {String} memberName - healthyName健康顾问，saleName销售顾问
   * @param {String} memberNum - 用户卡号
   */
  getMemberName = flow(function* (memberName, memberNum, isLSH = false) {
    const params = {
      cardCode: memberNum
    };
    if (
      !(this.applyType == '5' && Stores.AppMod.isCXY && _.isEmpty(this.areaResettleDetail)) &&
      memberName == 'saleName'
    ) {
      params.checkSaleNum = 1;
    }
    const { data, resultCode, resultMsg } = yield Serv.getMemberInfo(params);
    console.log(data, 'data is this', resultCode);
    if (resultCode == '0' && data) {
      if (data.realName) {
        this[memberName] =
          data.realName.length > 5
            ? `${data.realName[0]}...${data.realName[data.realName.length - 1]}`
            : data.realName;
      } else {
        this[memberName] = '';
      }
      if (memberName == 'saleName') {
        this.saleStatus = this.getMemberStatus(data.status);
        this.belongSystem = data.belongSystem;
      } else {
        this.healthyStatus = this.getMemberStatus(data.status);
      }
    } else if (resultCode == '174401') {
      Toast.fail(resultMsg);
    } else {
      this.belongSystem = '';
      this[memberName] = isLSH ? '' : null;
    }
  });

  getMemberStatus = (status) => {
    switch (status) {
      case 0:
        return '有效';
      case 1:
        return '未激活';
      case 2:
        return '未续约';
      case 3:
        return '注销';
      case 4:
        return '冻结';
      case 5:
        return '休眠期';
      default:
        return '';
    }
  };

  /**
   * 获取注册时所填写的健康顾问信息
   */
  getHealthyUser = flow(function* () {
    const { data, resultCode } = yield Serv.getHealthyUser();
    // 存在注册时填写的健康顾问，将其显示并不可编辑
    if (resultCode == '0' && data && data.healthConsultantNum) {
      this.initHealthy = data.healthConsultantNum;
      this.healthy = data.healthConsultantNum;
      this.getMemberName('healthyName', this.initHealthy);
      // 如果是自主开卡，销售顾问初始默认为健康顾问编号 || 虚拟资格注册开卡订单
      if (this.applyType == '3') {
        this.sale = data.healthConsultantNum;
        this.getMemberName('saleName', this.sale);
      }
    }
  });

  /**
   * DZC是否带出销售顾问，且不能更改
   */
  queryDZCMemberSaleNumber = flow(function* () {
    if (!this.healthy) return '';
    const { data, resultCode } = yield Serv.queryDZCMemberSaleNumber(this.healthy);
    // 存在注册时填写的健康顾问，将其显示并不可编辑
    if (resultCode == '0') {
      return data || '';
    }
    return '';
  });

  /**
   *校验销售顾问，DZC体系每个卡号最多当两个人的销售顾问
   *
   * @memberof MemCardMsgMod
   */
  checkSaleConsultNum = flow(function* () {
    const params = {
      healthConsultNum: this.healthy,
      saleConsultNum: this.sale
    };
    const { data, resultCode } = yield Serv.checkSaleConsultNum(params);
    // 存在注册时填写的健康顾问，将其显示并不可编辑
    if (resultCode == '0') {
      return true;
    }
    return false;
  });

  /**
   * 乘星吻月站点，会员代客注册，获取推荐人安置情况
   */
  loadAreaResettleData = flow(function* () {
    if (!this.healthy) return;
    try {
      const { data } = yield Serv.loadAreaResettleData(this.healthy);
      if (data) {
        this.areaResettleDetail = data || {};
        if (!Stores.AppMod.isWY) {
          // 不显示左右区的时候，左右区卡号一样，显示左右区的时候，默认选中左区，所以默认赋值左区卡号
          this.sale = this.areaResettleDetail.leftCardCode || this.healthy;
          // 请求销售顾问卡号对应的卡名称和卡状态
          this.getMemberName('saleName', this.sale);
        }
      }
    } catch (error) {}
  });

  /**
   * 自主开卡新逻辑
   */
  applyNext = flow(function* (cardTypeId) {
    try {
      const { healthy: healthConsultantNum, isInvite, isAgree: agree } = this;
      if (!healthConsultantNum) {
        Toast.info('请输入健康顾问信息！', 1);
        return;
      }
      let params = {
        registerCardReqDto: {
          healthConsultantNum,
          channel: 0, // 自主开卡
          isEntityCard: 0, // 虚拟卡
          agree
        }
      };
      // 被邀请开卡的，传多一个参数
      if (isInvite) {
        params.registerCardReqDto.inviteCode = params.registerCardReqDto.healthConsultantNum;
      }
      const { resultCode, resultMsg, data } = yield Serv.apply(params);
      if (resultCode == 9998) {
        this.initHealthy = '';
        this.healthy = '';
        this.getHealthyUser();
        Toast.fail('健康顾问已更新，请重新填写销售顾问~', 2);
        return;
      }
      if (resultCode != 0) {
        Toast.fail(resultMsg, 3);
        return;
      }

      // 神策数据发送
      window.sensors.track('registerMember', {});
      if (cardTypeId) {
        this.goSuccess({ params, healthConsultantNum, data, cardTypeId });
      } else {
        Toast.success(
          `提交成功，选购产品即可完成
        ${
          Stores.AppMod.userInfo && Stores.AppMod.userInfo.memberRetail
            ? openCardTextLess
            : oldOpenCardText
        }
        `,
          1,
          this.goSuccess({ params, healthConsultantNum, data, cardTypeId })
        );
      }
    } catch (error) {}
  });

  goSuccess = ({ params, healthConsultantNum, data, cardTypeId }) => {
    Util.setLocalCache(Config.localStorageKeys.member_applyCardMsg, params.registerCardReqDto);

    Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);
    // 判断是否是链接过来的开卡逻辑
    let item = data.find((item) => item.id == cardTypeId);
    if ((!item || !item.id) && cardTypeId) {
      Toast.fail('无购买权限，请联系健康顾问', 2, () => {
        window.app.routerRedirect({ pathname: '/shop/home' });
      });
      return;
    }
    if (cardTypeId) {
      window.app.routerRedirect({
        pathname: '/register/memGiftbag',
        clear: false,
        defaultCheck: true,
        state: {
          applyType: '3', // '4'会员开卡
          card: item,
          defaultCheck: true,
          cardTypeId
        }
      });
      return;
    }

    Util.setLocalCache(Config.localStorageKeys.menber_helpUserId, { healthConsultantNum });
    window.app.routerGoTo({
      pathname: '/register/memGiftbag',
      clear: true,
      state: {
        applyType: '3', // '3'代表自主开卡类型的礼包选购
        HealthyCardCode: healthConsultantNum
      }
    });
  };

  /**
   * 申请开卡，获取卡类型
   */
  apply = flow(function* (accumulate) {
    try {
      const {
        physicalCardNum,
        physicalCardPwd,
        businessName,
        certType,
        headBankId,
        headBankList,
        belongSystem,
        belongArea,
        sale
      } = this;
      if (businessName && !Util.checkInput(businessName, 'nonSymbol')) {
        Toast.info('商户名称仅限输入中英文数字~', 1);
        return;
      }
      this.realName = Util.getStrictName(this.realName);
      if (!this.realName) return;
      const params = {
        registerCardReqDto: {
          healthConsultantNum: this.healthy,
          saleConsultantNum: this.sale ? this.sale : this.healthy,
          realName: this.realName,
          identityCard: this.certNum,
          identityType: this.certType,
          birthday: this.birth,
          sex: this.gender,
          nation: this.nation,
          channel: 0
        }
      };
      // 被邀请开卡的，传多一个参数
      if (this.isInvite) {
        params.registerCardReqDto.inviteCode = params.registerCardReqDto.healthConsultantNum;
      }
      if (belongArea && (belongSystem == 'WDY' || belongSystem == 'DC' || belongSystem == 'CSS')) {
        params.registerCardReqDto.belongArea = belongArea;
        Stores.CheckOrderMod.changeState({ belongArea, sale });
      }
      // 如证件号为身份证，去掉生日和性别参数
      if (certType == 1) {
        delete params.registerCardReqDto.birthday;
        delete params.registerCardReqDto.sex;
      }
      // 非实体开卡时，需传密码和重复密码
      if (!physicalCardNum) {
        Object.assign(params.registerCardReqDto, {
          password: this.certNum ? rstr2b64(this.certNum.slice(-6)) : rstr2b64('123456'),
          confirmPassword: this.certNum ? rstr2b64(this.certNum.slice(-6)) : rstr2b64('123456'),
          isEntityCard: '0'
        });
        // 实体开卡时候，需传实体卡密和商户信息
      } else {
        let extension = {};

        headBankList.some((_val) => {
          if (_val.value == headBankId) {
            extension.bankName = _val.name;
            return true;
          }
        });
        if (this.businessAddress) {
          Object.assign(extension, {
            manageProvinceCode: this.businessAddress[0].value,
            manageCityCode: this.businessAddress[1].value,
            manageCountyCode: this.businessAddress[2].value
          });
        }
        Object.assign(
          params.registerCardReqDto,
          {
            bankNativePlaceProvinceCode: this.bankAddress[0].value,
            bankNativePlaceCityCode: this.bankAddress[1].value,
            branchCode: this.branchBankId,
            bankAccount: this.bankNum,
            entityCardCode: physicalCardNum,
            entityPassword: physicalCardPwd,
            address: this.detailAddress,
            educational: this.level,
            job: this.job,
            isEntityCard: '1'
          },
          extension
        );
        if (this.businessName) params.registerCardReqDto.merchantName = this.businessName;
      }
      if (accumulate) {
        const userId = Stores.AppMod.userInfo.id || '';
        const theResultValue = yield Serv.accumulateUserInfo({
          ...params.registerCardReqDto,
          userId
        });
        return theResultValue;
      }
      if (localStorage.getItem('noOrderToOpenCard') == 1) {
        runInAction(() => {
          Stores.CheckOrderMod.changeState({ orderType: this.applyType });
        });
        setTimeout(() => {
          Util.setLocalCache(
            Config.localStorageKeys.member_applyCardMsg,
            params.registerCardReqDto
          );
          Stores.CheckOrderMod.addOrder('', 1);
        }, 100);
        return;
      }
      if (Util.getLocalCache('isVirtualPoint')) {
        if (Util.getLocalCache('virtualNeedOrder') == 1) {
          let vrMsgData = {
            healthConsultantNum: this.healthy || Stores.AppMod.userInfo.cardCode,
            helpUserId: Util.getLocalCache('virtualUserId'),
            channel: 2,
            isEntityCard: 0 // 0 虚拟卡 1 实体卡
          };
          let vrParams =
            Util.getLocalCache(Config.localStorageKeys.virtual_applyCardOrderParams) || {};
          Object.assign(params.registerCardReqDto, vrMsgData);
          Util.setLocalCache(
            Config.localStorageKeys.virtual_applyCardMsg,
            params.registerCardReqDto
          );
          Stores.CheckOrderMod.confirmOrder(vrParams, '', 'giftbag');
          return;
        }
        const theResultValue = yield Serv.accumulateUserInfo({
          ...params.registerCardReqDto,
          ...(Util.getLocalCache('isVirtualPoint')
            ? {
                virtualPointId: Util.getLocalCache('virtualPointId'),
                userId: Util.getLocalCache('virtualUserId'),
                targetVirtualPlanId: Util.getLocalCache('targetVirtualPlanId')
              }
            : {})
        });
        return theResultValue;
      }

      const resultValue = yield Serv.apply(params, 1);
      const { resultCode, resultMsg, data } = resultValue || {};
      if (resultCode == 9998) {
        this.initHealthy = '';
        this.healthy = '';
        this.getHealthyUser();
        Toast.fail('健康顾问已更新，请重新填写销售顾问~', 2);
        return;
      }
      if (resultCode != 0) {
        Toast.fail(resultMsg, 3);
        return;
      }

      // 神策数据发送
      window.sensors.track('registerMember', {});
      Toast.success('提交成功', 1, () => {
        Util.setLocalCache(Config.localStorageKeys.member_applyCardMsg, params.registerCardReqDto);

        Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);

        // 缓存填写的信息，以便下次同个手机号进来，无需再次填写
        Util.setLocalCache(Config.localStorageKeys.member_cardFillMsg, {
          phone: this.phone,
          businessAddress: this.businessAddress,
          businessName: this.businessName,
          detailAddress: this.detailAddress,
          // password: this.password,
          sale: this.sale,
          realName: this.realName,
          certType: this.certType,
          certNum: this.certNum,
          birth: this.birth,
          gender: this.gender,
          level: this.level || '',
          job: this.job || '',
          nation: this.nation,
          bankAddress: this.bankAddress || null,
          headBankId: this.headBankId || '',
          branchBankId: this.branchBankId || '',
          branchBankName: this.branchBankName,
          bankNum: this.bankNum || ''
        });
        // window.app.routerGoTo({
        //   pathname: '/register/memGiftbag',
        //   clear: true,
        //   state: {
        //     // '3'代表自主开卡类型的礼包选购
        //     applyType: '3',
        //   },
        // });
      });
      return resultValue;
    } catch (error) {
      console.log('error', error);
      if (error && error.resultMsg) {
        setTimeout(() => {
          Toast.fail(error.resultMsg, 3);
        }, 500);
      }
    }
  });

  /**
   * 新客注册信息提交，获取卡类型
   */
  agentApply = flow(function* (ldOrder) {
    const { baseInfoRequired } = Stores.AppMod.cardInfo;

    try {
      const {
        physicalCardNum,
        physicalCardPwd,
        businessName,
        certType,
        headBankId,
        headBankList,
        belongSystem,
        belongArea,
        sale,
        isSingapore
      } = this;
      if (businessName && !Util.checkInput(businessName, 'nonSymbol')) {
        Toast.info('商户名称仅限输入中英文数字', 1);
        return;
      }
      // 证件号做第二层验证
      if (!Util.checkInput(this.certNum, 'nonSymbol') && baseInfoRequired != 0 && !isSingapore) {
        Toast.info('证件号码格式有误~', 1);
        return;
      }
      if (
        this.certType == 1 &&
        /[\u4e00-\u9fa5]/g.test(this.certNum) &&
        baseInfoRequired != 0 &&
        !isSingapore
      ) {
        Toast.info('身份证格式有误~', 1);
        return;
      }
      this.realName = Util.getStrictName(this.realName);
      if (!this.realName) return;
      const params = {
        registerCardReqDto: {
          healthConsultantNum: this.healthy,
          saleConsultantNum: this.sale,
          realName: this.realName || this.phone,
          identityCard: this.certNum,
          identityType: this.certType,
          birthday: this.birth,
          sex: this.gender,
          helpUserId: this.agentId,
          channel: 2
        }
      };
      // 如证件号为身份证，去掉生日和性别参数
      if (certType == 1) {
        delete params.registerCardReqDto.birthday;
        delete params.registerCardReqDto.sex;
      }
      if (this.nation || this.nation === 0) {
        params.registerCardReqDto.nation = this.nation;
      }
      // 非实体开卡时，需传密码和重复密码
      if (!physicalCardNum) {
        Object.assign(params.registerCardReqDto, {
          password: this.certNum ? rstr2b64(this.certNum.slice(-6)) : rstr2b64('123456'),
          confirmPassword: this.certNum ? rstr2b64(this.certNum.slice(-6)) : rstr2b64('123456'),
          isEntityCard: '0'
        });
      } else {
        // 实体开卡时候，需传实体卡密和商户信息
        let extension = {};

        headBankList.some((_val) => {
          if (_val.value == headBankId) {
            extension.bankName = _val.name;
            return true;
          }
        });
        if (this.businessAddress) {
          Object.assign(extension, {
            manageProvinceCode: this.businessAddress[0].value,
            manageCityCode: this.businessAddress[1].value,
            manageCountyCode: this.businessAddress[2].value
          });
        }
        Object.assign(
          params.registerCardReqDto,
          {
            bankNativePlaceProvinceCode: this.bankAddress[0].value,
            bankNativePlaceCityCode: this.bankAddress[1].value,
            branchCode: this.branchBankId,
            bankAccount: this.bankNum,
            entityCardCode: physicalCardNum,
            entityPassword: physicalCardPwd,
            address: this.detailAddress,
            educational: this.level,
            job: this.job,
            isEntityCard: '1'
          },
          extension
        );
        if (this.businessName) params.registerCardReqDto.merchantName = this.businessName;
      }

      if (Stores.AppMod.isCXY || Stores.AppMod.isWY) {
        Util.setLocalCache(Config.localStorageKeys.modifySaleTag, this.isSaleChange ? 1 : 0);
      }

      if (
        belongArea &&
        (belongSystem == 'WDY' ||
          belongSystem == 'DC' ||
          (+this.applyType === 5 && belongSystem == 'TH'))
      ) {
        Stores.CheckOrderMod.changeState({ belongArea, sale });
        params.registerCardReqDto.belongArea = belongArea;
      }
      if (localStorage.getItem('noOrderToOpenCard') == 1) {
        runInAction(() => {
          Stores.CheckOrderMod.changeState({ orderType: this.applyType });
        });
        setTimeout(() => {
          Util.setLocalCache(
            Config.localStorageKeys.member_agentApplyCardMsg,
            params.registerCardReqDto
          );
          Stores.CheckOrderMod.addOrder('', 1);
        }, 100);
        return;
      }
      if (ldOrder) {
        // applyType 自主开卡-'3', 会员代客注册-'7'
        // type: 1-自主开卡  2-自主升级  3-代新客注册  4-店铺代老客升级 6-会员代老客升级
        const type = this.applyType === '3' ? 1 : this.applyType === '5' ? 3 : '';
        Util.setLocalCache(
          Config.localStorageKeys.member_agentApplyCardMsg,
          params.registerCardReqDto
        );
        Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
          dgUserId: this.agentId
        });
        Stores.CheckOrderMod.confirmLDOrder({ type, inletTitle: this.inletTitle });
        return;
      }

      const resultValue = yield Serv.apply(params, 1);
      const { resultMsg, resultCode, data } = resultValue || {};
      if (resultCode == 9998) {
        this.initHealthy = '';
        this.healthy = '';
        this.getHealthyUser();
        Toast.fail('健康顾问已更新，请重新填写销售顾问~', 2);
        return;
      }
      if (resultCode != 0) {
        Toast.fail(resultMsg, 3);
        return;
      }

      // 神策数据发送
      window.sensors.track('registerMember', {});

      const agentApplyCardMsg =
        Util.getLocalCache(Config.localStorageKeys.member_agentApplyCardMsg) || {};

      Util.setLocalCache(Config.localStorageKeys.member_agentApplyCardMsg, {
        ...params.registerCardReqDto,
        areaCode: agentApplyCardMsg.areaCode
      });
      Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);
      Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
        dgUserId: this.agentId
      });
      // 缓存填写的信息，以便下次同个手机号进来，无需再次填写
      Util.setLocalCache(Config.localStorageKeys.member_cardFillMsg, {
        phone: this.phone,
        businessAddress: this.businessAddress,
        businessName: this.businessName,
        detailAddress: this.detailAddress,
        // password: this.password,
        sale: this.sale,
        realName: this.realName,
        certType: this.certType,
        certNum: this.certNum,
        birth: this.birth,
        gender: this.gender,
        level: this.level,
        job: this.job || '',
        nation: this.nation || '',
        bankAddress: this.bankAddress || null,
        headBankId: this.headBankId || '',
        branchBankId: this.branchBankId || '',
        branchBankName: this.branchBankName,
        bankNum: this.bankNum || ''
      });
      Toast.success('提交成功', 1, () => {
        // window.app.routerGoTo({
        //   pathname: '/register/memGiftbag',
        //   clear: true,
        //   state: {
        //     // '5'代表会员新客注册类型的礼包选购
        //     applyType: '5',
        //   },
        // });
      });
      // 腾晖云仓订单，直接调用submitRegisterCardOrder接口
      if (Util.getLocalCache(Config.localStorageKeys.th_cloud_warehouse)) {
        // 此处加定时器，是因为add中有toast的loading会把上面的toast.success顶掉，后面的callback就不会执行了
        const timer = setTimeout(() => {
          timer && clearTimeout(timer);
          this.addTHRegisterOrder(params.registerCardReqDto);
        }, 1000);
        return {};
      }

      return resultValue;
    } catch (error) {}
  });

  /**
   * 腾晖云仓会员注册下单
   *
   * @memberof MemGiftbagMod
   */
  addTHRegisterOrder = flow(function* (registerCardReqDto) {
    const submitUrl = 'user/register/submitRegisterCardOrder';
    const submitParams =
      Util.getLocalCache(Config.localStorageKeys.th_cloud_register_submit_params) || '{}';

    submitParams.registerCardReqDto = registerCardReqDto;
    submitParams.confirmReqId = Util.getLocalCache(Config.localStorageKeys.confirm_req_id) || ''; // 开卡、升级下单慢接口优化加传

    try {
      Toast.loading('请稍候', 100);
      const { data: submitData } = yield Serv.addOrder(submitUrl, submitParams);
      Toast.hide();
      if (submitData) {
        Util.setLocalCache(Config.localStorageKeys.confirm_req_id, ''); // 清除缓存
        const tradeNo = typeof data === 'object' ? submitData.tradeNo : submitData;
        Util.setLocalCache(Config.localStorageKeys.th_cloud_register_submit_params, '');
        window.app.routerRedirect(`/shop/payMent/${tradeNo}`);
      }
    } catch (err) {
      console.log('dashjkhkda===>', err);
    }
  });

  getCertTypeState = () => {
    const { baseInfoRequired } = Stores.AppMod.cardInfo;
    if (!(baseInfoRequired != 1) && !this.isSingapore) {
      return `${this.certType}` && `${this.certNum}`;
    } else {
      return true;
    }
  };
  /**
   * 按钮是否可点
   */
  @computed get disabled() {
    const { baseInfoRequired } = Stores.AppMod.cardInfo;
    // 非实体卡开卡时，没填密码或重复密码
    // let disabled_1 = !this.physicalCardNum && (!this.password || !this.passwordAgain);
    // 实体卡开卡时，没填商户地址和详细地址
    let disabled_2 = this.physicalCardNum && (!this.businessAddress || !this.detailAddress);
    // 选择非身份证时，没填生日或性别
    let disabled_3 = this.certType != 1 && (!this.birth || !this.gender);
    console.log(
      'Stores.AppMod.cardInfo.saleConsultantDisplay',
      Stores.AppMod.cardInfo.saleConsultantDisplay
    );
    // 其他必填项未填写时
    let disabled_4 = !(
      `${this.healthy}` &&
      (Stores.AppMod.cardInfo.saleConsultantDisplay == 1 ? `${this.sale}` : true) &&
      `${this.realName}` &&
      this.getCertTypeState() &&
      `${(Stores.AppMod.internationalConfig || {}).hideNation ? true : this.nation}`
    );
    if (baseInfoRequired == 0) {
      disabled_3 = false;
      disabled_4 = !(
        `${this.healthy}` &&
        (Stores.AppMod.cardInfo.saleConsultantDisplay == 1 ? `${this.sale}` : true) &&
        `${this.realName}` &&
        `${(Stores.AppMod.internationalConfig || {}).hideNation ? true : this.nation}`
      );
    }
    let disabled_5 =
      this.physicalCardNum &&
      !(
        `${this.bankAddress}` &&
        (this.headBankId || this.headBankId == 0) &&
        `${this.branchBankId}` &&
        `${this.bankNum}` &&
        `${this.level}` &&
        `${this.job}`
      );
    console.log(this.branchBankId);
    console.log(this.headBankId, 'this.headBankId');
    console.log(disabled_2, disabled_3, disabled_4, disabled_5);
    return disabled_2 || disabled_3 || disabled_4 || disabled_5;
  }

  getUserShouldSupply = flow(function* () {
    try {
      const { data } = yield Serv.getUserShouldSupply();
      this.showShouldSupply = data;
      return data;
    } catch (error) {}
  });
}
const memCardMsgMod = new MemCardMsgMod();
export default memCardMsgMod;



// WEBPACK FOOTER //
// ./src/pages/Register/MemCardMsg/MemCardMsgMod.js